import Command from '../../actions/command';
import {call, fork, put, take} from 'redux-saga/effects';
import {Action} from 'redux-actions';
import {AddCompanyVotePayload} from '../../actions/companyCommand';
import Event from '../../actions/event';
import Api from '../../../api';

const onAddCompanyVoteData = function*(data: AddCompanyVotePayload) {
    try {
        yield call(Api.Command.addCompanyVote, {
            companyId: data.companyId,
            vote: data.vote,
        });

        yield put(Event.Company.companyVoteAdded({
            ...data,
        }));

        yield put(Command.Notification.enqueueNotification({
            severity: 'success',
            message: 'Dein Voting wurde erfolgreich abgegeben.',
        }));
    } catch (e) {
        yield put(Command.Notification.enqueueNotification({
            severity: 'error',
            message: 'Dein Voting konnte nicht abgegeben werden. Bitte versuche es später erneut.',
        }));
    }
};

export function* addCompanyVoteFlow() {
    while (true) {
        const action: Action<AddCompanyVotePayload> = yield take(
            Command.Company.addCompanyVote.toString(),
        );

        yield fork(onAddCompanyVoteData, action.payload);
    }
}
